import { vendorTypeEnum } from 'src/services/vendors/models'

type CuentaDeCobroVendor =
  | {
      vendorType?: string | null
      taxId?: string | null
      identificationNumber?: string | null
    }
  | null
  | undefined

/**
 * Returns the i18n key for the first failed pre-validation check when generating
 * a cuenta de cobro, or `null` if the vendor is valid. Checks run in priority order:
 * vendor present -> individual -> has tax id -> has identification number.
 */
export function cuentaDeCobroVendorError(vendor: CuentaDeCobroVendor): string | null {
  if (!vendor) return 'cuentaDeCobro.validation.noVendor'
  if (vendor.vendorType !== vendorTypeEnum.INDIVIDUAL)
    return 'cuentaDeCobro.validation.notIndividual'
  if (!vendor.taxId) return 'cuentaDeCobro.validation.missingTaxId'
  if (!vendor.identificationNumber) return 'cuentaDeCobro.validation.missingIdentificationNumber'
  return null
}
